import React, { useState } from "react";
import { InternalContent } from "@components/library";
import TopBalance from "@components/library/TopBalance";
import Crypto from "./components/Crypto";
import { useSelector } from "react-redux";

// import "./index.sass";
import { useTranslation } from "@helpers/translate";
import { Helmet } from "react-helmet";
// import axios from "@helpers/axios/private.axios";

export const History = () => {
  const { theme } = useSelector((state) => state.theme);

  const [operation] = useState("all");
  const { __ } = useTranslation();

  // const exportHistory = async (format) => {
  //   try {
  //     const resp = await axios.get(`/transaction/history/export/${format}`, {
  //       responseType: "blob",
  //     });
  //     const blob = new Blob([resp.data], { type: "text/plain" });

  //     const a = document.createElement("a");
  //     a.href = URL.createObjectURL(blob);
  //     a.style.display = "none";
  //     a.download = `transactions.${format}`;
  //     document.body.appendChild(a);
  //     a.click();
  //     a.remove();
  //   } catch (e) {
  //     // console.error(e);
  //   }
  // };

  return (
    <InternalContent
      bgImg={`../images/bg/bg-lamba${theme === "white" ? "-white" : ""}.png`}
    >
      <Helmet>
        <title>
          {__("seo.transaction_history")} {__("seo.divider")} {__("seo.title")}
        </title>
      </Helmet>

      <TopBalance />

      {/* <div className="tabs-t-history__btns">
        <Button
          className="tabs-t-history__btn"
          color="border"
          size="mini-w"
          type="button"
          onClick={() => exportHistory("csv")}
        >
          {__("common.export")} CSV
        </Button>                                                <-- На дизайні відсутні ккопки експорту!
        <Button
          className="tabs-t-history__btn"
          color="orange"
          size="mini-w"
          type="button"
          onClick={() => exportHistory("xlsx")}
        >
          {__("common.export")} XLSX
        </Button>
      </div> */}

      <div className="tab-content tab-content--mini wallet-history-tab">
        <Crypto operation={operation} />
      </div>
    </InternalContent>
  );
};

export default History;
